import { atom } from 'recoil';

export const navigationHandlerAtom = atom<{
  onBack?: () => void;
  onForward?: () => void;
}>({
  key: 'navigationHandlerAtom',
  default: {
    onBack: undefined,
    onForward: undefined
  }
});
